<template>
  <div>
    <div id="head-contact" class="bg-grad">
      <h2 class="text-white text-center">
        {{ $t("organisationFonctionnement.header.title") }}
      </h2>
    </div>

    <section class="container mt-5">
      <div class="mb-5">
        <h2 class="fw-bold display-6 text-primary">
          {{ $t("organisationFonctionnement.sections.firstContact.title") }}
        </h2>

        <p
          class="mt-3 text-container"
          style="font-size: 1.15rem; line-height: 1.7"
        >
          {{ $t("organisationFonctionnement.sections.firstContact.p1") }}
        </p>

        <p class="mt-3" style="font-size: 1.15rem; line-height: 1.7">
          {{
            $t(
              "organisationFonctionnement.sections.firstContact.p2.beforeStrong"
            )
          }}
          <strong>{{
            $t("organisationFonctionnement.sections.firstContact.p2.strong")
          }}</strong>
          {{
            $t(
              "organisationFonctionnement.sections.firstContact.p2.afterStrong"
            )
          }}
        </p>
      </div>

      <div class="mb-5">
        <h2 class="fw-bold display-6 text-primary">
          {{ $t("organisationFonctionnement.sections.proposal.title") }}
        </h2>

        <div
          class="mt-3 text-container"
          style="font-size: 1.15rem; line-height: 1.7"
        >
          <p>
            {{
              $t("organisationFonctionnement.sections.proposal.p1.beforeStrong")
            }}
            <strong>{{
              $t("organisationFonctionnement.sections.proposal.p1.strong")
            }}</strong
            >{{
              $t("organisationFonctionnement.sections.proposal.p1.afterStrong")
            }}
          </p>

          <ul>
            <li>
              {{
                $t("organisationFonctionnement.sections.proposal.list.item1")
              }}
            </li>
            <li>
              {{
                $t("organisationFonctionnement.sections.proposal.list.item2")
              }}
            </li>
            <li>
              {{
                $t("organisationFonctionnement.sections.proposal.list.item3")
              }}
            </li>
          </ul>

          <p>
            {{ $t("organisationFonctionnement.sections.proposal.p2") }}
          </p>
        </div>
      </div>

      <div class="mb-5">
        <h2 class="fw-bold display-6 text-primary">
          {{ $t("organisationFonctionnement.sections.planning.title") }}
        </h2>

        <p
          class="mt-3 text-container"
          style="font-size: 1.15rem; line-height: 1.7"
        >
          {{ $t("organisationFonctionnement.sections.planning.p1") }}
        </p>

        <p
          class="mt-3 text-container"
          style="font-size: 1.15rem; line-height: 1.7"
        >
          <strong>{{
            $t("organisationFonctionnement.sections.planning.p2.strongTitle")
          }}</strong
          ><br />
          {{ $t("organisationFonctionnement.sections.planning.p2.text") }}
        </p>
      </div>

      <div class="mb-5">
        <h2 class="fw-bold display-6 text-primary">
          {{ $t("organisationFonctionnement.sections.followUp.title") }}
        </h2>

        <p
          class="mt-3 text-container"
          style="font-size: 1.15rem; line-height: 1.7"
        >
          {{ $t("organisationFonctionnement.sections.followUp.p1") }}
        </p>
      </div>
    </section>

    <!-- CALL TO ACTION -->
    <Cta />
  </div>
</template>

<script>
import { useHead } from "@vueuse/head";
import { useI18n } from "vue-i18n";

import Cta from "@/components/Cta.vue";

export default {
  name: "OrganisationFonctionnement",
  components: {
    Cta,
  },
  setup() {
    const { t } = useI18n();

    useHead(() => ({
      title: t("organisationFonctionnement.meta-data.title"),
      meta: [
        {
          name: "description",
          content: t("organisationFonctionnement.meta-data.desc"),
        },
      ],
    }));
  },
};
</script>

<style scoped>
#head-contact {
  color: white;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
